import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import vtextfield from "@busy-human/vue-component-library/components/text-field.vue"
import VCheckbox from '@/components/checkmarkbox.vue'
import VRadioset from '@busy-human/vue-component-library/components/radioset.vue'
import { Userspaces } from '@busy-human/opt-library';
import { signup, sendVerification, emailLogin, phoneLogin, getUserId } from '@/util/auth';
import VLoader from '@/components/loader.vue'
import { computed } from '@vue/reactivity';
import VCodeInput from "../../components/code-input.vue"
import VPhoneInput from "@/components/phone-input.vue";
import {isDevEnv} from "../../util/aux-functions";

type Props = {
    isLogin: boolean
}
type Emits = {
    (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'auth-verification',
  props: {
    isLogin: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    isLogin: boolean
}





const env = ref(ENVIRONMENT);

const firstname = ref("");
const lastname = ref("");
const email = ref("");
const phone = ref("");
const userDidSignupFromMeetingInvite = ref(true)

const acceptedTerms = ref(false);
const verificationRadioOptions = [
    {label: "Phone", value: 'phone'},
    {label: "Email", value: 'email'},
] as const;
const verificationSelection = ref<typeof verificationRadioOptions[number]['value']>('phone');
const codeSent = ref(false);
const loading = ref(false);
const errorMsg = ref<null | string>(null);
const accountCreated = ref(false);
const isDevEnvironment = ref(false);
isDevEnvironment.value = isDevEnv(window);

const DEV_code = ref<string | null>(null);

const codeSentTo = computed(() => verificationSelection.value === 'email' ? email.value : phone.value);

const emailRegex = /(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

const validate = (focus?:string) => {
    errorMsg.value = ""

    if(!focus || focus == 'email')
        if((!props.isLogin || verificationSelection.value === 'email') && (!email.value || !emailRegex.test(email.value.toLowerCase()))){
            errorMsg.value = "Input a Valid Email Address"
            return false;
        }

    if(!focus || focus == 'phone')
        if((!props.isLogin || verificationSelection.value === 'phone') && (!phone.value || !phoneRegex.test(phone.value.toLowerCase()))){
            errorMsg.value = 'Input a Valid Phone Number'
            return false;
        }
    return true;
}

watch([email], vals => {
    validate('email');
})

watch([phone], vals => {
    validate('phone');
})

watch([verificationSelection], vals => {
    validate(verificationSelection.value)
})

const doSendCode = async () => {
    errorMsg.value = null;

    if(!validate()) return;

    const phoneNumber = phone.value;

    loading.value = true;
    if(!props.isLogin){
        try {
            if(!accountCreated.value) await signup(firstname.value, lastname.value, email.value, phoneNumber,userDidSignupFromMeetingInvite.value)
            accountCreated.value = true;
        } catch (e) {
            loading.value = false;
            if(e instanceof Error) {
                errorMsg.value = e.message;
            } else {
                errorMsg.value = "Error trying to create account"
            }
            console.error(e);
            return;
        }
    }

    try {
        const verificationString = verificationSelection.value === 'email'
            ? email.value
            : phoneNumber;

        let result = await sendVerification(verificationSelection.value, verificationString);
        DEV_code.value = result.data.code || null

        codeSent.value = true;
        loading.value = false;
    } catch(e) {
        console.error(e);
        loading.value = false;
        errorMsg.value = "Error trying to send verification code, try a different method.";
        return;
    }
}

const inputCode = ref('');
watch(() => inputCode.value, val => {
    if(val.length === 5) {
        doCodeSubmission(val);
    }
})
const doCodeSubmission = async (code: string) => {
    loading.value = true;
    try {
        if(verificationSelection.value == 'email') {
            await emailLogin(email.value, code);
        } else if (verificationSelection.value == 'phone') {
            await phoneLogin(phone.value, code);
        }
        await store.initialize(getUserId());
        loading.value = false;
        emit('close');
    } catch (e) {
        errorMsg.value = 'Error: Invalid Code';
        loading.value = false;
    }
}


const __returned__ = { props, emit, env, firstname, lastname, email, phone, userDidSignupFromMeetingInvite, acceptedTerms, verificationRadioOptions, verificationSelection, codeSent, loading, errorMsg, accountCreated, isDevEnvironment, DEV_code, codeSentTo, emailRegex, phoneRegex, validate, doSendCode, inputCode, doCodeSubmission, ref, watch, vtextfield, VCheckbox, VRadioset, Userspaces, signup, sendVerification, emailLogin, phoneLogin, getUserId, VLoader, computed, VCodeInput, VPhoneInput, isDevEnv }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})